"use client";

import { useEffect } from "react";

import RoomList from "@/components/sections/Rooms/RoomList";
import { useLanguage } from "@/contexts/LanguageContext";
import type { GuessRoom, Room } from "@/payload-types";
import type { PayLoadData } from "@/utils/payloadUtil";

export function RoomsPageContent({
  pageData,
}: {
  pageData: PayLoadData<GuessRoom> | undefined;
}) {
  const { language } = useLanguage();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <RoomList
        rooms={
          (pageData?.[language].rooms?.map(({ room }) => room) || []) as Room[]
        }
      />
    </>
  );
}
